module.exports = __webpack_public_path__ + "img/Master-3.4d4ffe68.png";